export default __webpack_public_path__ + "static/media/protect-img.61df5daa.png";